import { render } from "./AppTitleBarBase.vue?vue&type=template&id=2954ecb8"
import script from "./AppTitleBarBase.vue?vue&type=script&lang=js"
export * from "./AppTitleBarBase.vue?vue&type=script&lang=js"

import "./AppTitleBarBase.vue?vue&type=style&index=0&id=2954ecb8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__